module.exports = __webpack_public_path__ + "img/code.756353b4.jpg";